import { useDispatch, useSelector } from 'react-redux'
import { isAvatarBig } from '@amplify/avatar-builder'

import { avatarCompatibleGradesMap } from 'app/constants/avatar.constants'
import { GRADES } from 'app/types/grades.types'

import { RootState } from '..'

export enum AvatarActions {
  saveBigAvatar = 'SAVE_BIG_AVATAR',
  saveSmallAvatar = 'SAVE_SMALL_AVATAR',
}

type Action = {
  type: AvatarActions
  config: unknown
}

type State = {
  bigAvatarConfig: unknown
  smallAvatarConfig: unknown
}

const initialState: State = {
  bigAvatarConfig: null,
  smallAvatarConfig: null,
}

// eslint-disable-next-line default-param-last
export const avatarBuilderReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case AvatarActions.saveBigAvatar:
      return {
        ...state,
        bigAvatarConfig: action.config,
      }
    case AvatarActions.saveSmallAvatar:
      return {
        ...state,
        smallAvatarConfig: action.config,
      }
    default:
      return state
  }
}

export const useAvatar = (grade: GRADES | '') => {
  const isBig = grade && isAvatarBig(avatarCompatibleGradesMap[grade])

  const characterAssets = useSelector<RootState>(({ avatarBuilder }) =>
    isBig ? avatarBuilder.bigAvatarConfig : avatarBuilder.smallAvatarConfig
  )

  const dispatch = useDispatch()

  const saveAvatar = (config: unknown) =>
    dispatch({
      type: isBig ? AvatarActions.saveBigAvatar : AvatarActions.saveSmallAvatar,
      config,
    })

  return { characterAssets, saveAvatar }
}
